/**
 * Coerce sheet / form values into HyperFormula-friendly primitives.
 */

const CURRENCY_RE = /[$,\s]/g;
const ERROR_DISPLAY_RE = /^#(VALUE|REF|DIV\/0|N\/A|NAME|NULL|NUM|ERROR)!?$/i;

export const isSheetErrorDisplay = value =>
  ERROR_DISPLAY_RE.test(String(value || '').trim());

export const coerceSheetValue = value => {
  if (value === undefined || value === null || value === '') return null;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'object') return null;

  const raw = String(value).trim();
  if (!raw || raw.startsWith('{{') || isSheetErrorDisplay(raw)) return null;

  if (raw.endsWith('%')) {
    const pct = Number(raw.slice(0, -1).replace(CURRENCY_RE, ''));
    return Number.isFinite(pct) ? pct / 100 : null;
  }

  const asNumber = Number(raw.replace(CURRENCY_RE, ''));
  if (raw !== '' && Number.isFinite(asNumber) && /[\d.]/.test(raw)) {
    return asNumber;
  }

  return raw;
};

/** User-facing formula result: never show spreadsheet errors. */
export const formatFormulaDisplay = value => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return '—';
    if (Number.isInteger(value)) return String(value);
    return String(Math.round(value * 100) / 100);
  }
  if (typeof value === 'boolean') return value ? 'TRUE' : 'FALSE';
  const text = String(value).trim();
  if (!text || isSheetErrorDisplay(text)) return '—';
  return text;
};
